import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
} from "@mui/material";
import { SubmitHandler } from "react-hook-form";
import DateComIntervalo from "../../../../../../components/DateComIntervalo";
import SelectLoja from "../../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import { IDataLojas } from "../../../../../../types/api/geral/pesquisar-lojas";
import { useState } from "react";
import { Moment } from "moment";
import { FilterProps } from "..";

export default function DialogFilter({
  defaultValues,
  openDialogFilter,
  onClose,
  onSubmit,
  onClear
}: DialogFilterProps) {
  const [filters, setFilters] = useState<FilterProps>(defaultValues);

  const handleChangeFilter = (
    prop: keyof FilterProps,
    value: Moment | null | string | IDataLojas | null
  ) => {
    setFilters((prevState) => ({
      ...prevState,
      [prop]: value,
    }));
  };

  const handleChangeData = (data: { inicial: Moment | null; final: Moment | null }) => {
    setFilters((prevState) => ({
      ...prevState,
      dataCriacao: data.inicial,
      dataFim: data.final,
    }));
  };

  const handleSubmit = () => {
    onSubmit(filters);
  };

  return (
    <Dialog open={openDialogFilter} onClose={onClose}>
      <DialogTitle>Filtros</DialogTitle>

      <DialogContent>
        <Box my={1}>
          <Grid container spacing={2}>
            <Grid size={{xs: 12}}>
              <DateComIntervalo
                data={{
                  inicial: filters.dataCriacao,
                  final: filters.dataFim
                }}
                onChangeData={handleChangeData}
                datePickerView={['year', 'month', 'day']}
                formatString="DD/MM/YYYY"
                labelInput="Período"
              />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
              <TextField
                fullWidth
                label="Número do pedido"
                variant="outlined"
                value={filters.numeroPedido}
                onChange={(e) => handleChangeFilter("numeroPedido", e.target.value)}
              />
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
              <TextField
                fullWidth
                label="Código CS9"
                variant="outlined"
                value={filters.codigoCS9}
                onChange={(e) => handleChangeFilter("codigoCS9", e.target.value)}
              />
            </Grid>
            <Grid size={{xs: 12}}>
              <SelectLoja
                value={filters.lojaSolicitante}
                onChange={(value) => handleChangeFilter("lojaSolicitante", value)}
                fieldLabel="Loja solicitante"
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClear}>Limpar</Button>

        <Button variant="contained" onClick={handleSubmit}>Aplicar</Button>
      </DialogActions>
    </Dialog>
  );
}

interface DialogFilterProps {
  defaultValues: FilterProps;
  openDialogFilter: boolean;
  onClose: () => void;
  onClear: () => void;
  onSubmit: SubmitHandler<FilterProps>;
}
